export class Todo {
    constructor(public text: string) {
    }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/shared/todo/index.ts